module.exports = __webpack_public_path__ + "src/modules/connection/assets/sounds/agentSoundEffect.m4a";